import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogDocumento } from '../../model/logDocumento.model';

@Component({
  selector: 'app-modal-log',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './modal-log.component.html',
  styleUrl: './modal-log.component.css'
})
export class ModalLogComponent implements OnInit {
  logs: LogDocumento[] = [];

  constructor(
    public dialogRef: MatDialogRef<ModalLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { logs: LogDocumento[] }
  ) {
    this.logs = data?.logs || [];
  }

  ngOnInit() {
  }

  fechar() {
    this.dialogRef.close();
  }

  formatarData(data: Date | string): string {
    if (!data) return '';
    const dataObj = new Date(data);
    return dataObj.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  formatarHora(data: Date | string): string {
    if (!data) return '';
    const dataObj = new Date(data);
    return dataObj.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatarDescricao(log: LogDocumento): string {
    if (!log.descricao) return '';

    let descricao = log.descricao;
    descricao = descricao.replace(/O usuário\s+([^(]+)\s*\(/g,
      'O usuário <span class="usuario-destaque">$1</span> (');
    descricao = descricao.replace(/arquivo\s+([^\s<]+)/g,
      'arquivo <strong>$1</strong>');
    descricao = descricao.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    return descricao;
  }

  formatarAcao(acao: string): string {
    const acaoUpper = acao?.toUpperCase() || '';
    const acoesFormatadas: { [key: string]: string } = {
      'CRIACAO': 'Criação',
      'EXCLUSAO': 'Exclusão',
      'INATIVACAO': 'Inativação',
      'ALTERACAO': 'Alteração',
      'DOWNLOAD': 'Download',
      'VISUALIZACAO': 'Visualização',
    };
    return acoesFormatadas[acaoUpper] || acao;
  }

  getImagemAcao(acao: string): string {
    const acaoLower = acao?.toLowerCase() || '';
    const imagensPorAcao: { [key: string]: string } = {
      'download': './assets/icone/download.svg',
      'visualizacao': './assets/icone/visualizou.svg',
      'criacao': './assets/icone/criacao.svg',
      'exclusao': './assets/icone/exclusao.svg',
      'inativacao': './assets/icone/inativacao.svg',
      'alteracao': './assets/icone/alteracao.svg',
    };
    return imagensPorAcao[acaoLower] || './assets/icone/logs.svg';
  }
}
